module.exports = __webpack_public_path__ + "img/box6-17.71d62344.png";